<template>
  <div class="comment">
    <!--      评论列表-->
    <div
      ref="comment-list"
      class="comment-list flex flex-col"
    >
      <template v-if="comments">
        <template v-if="comments.length > 0">
          <div
            v-for="(item, index) in comments"
            :key="'comment-' + index"
            class="comment-item w-full flex flex-start"
            :class="[{ myself: item.isMyself }]"
          >
            <div class="fixed-flex-item shrink-0 avatar">
              <Avatar
                class="w-full h-full bg-fill-5"
                shape="circle"
                :image-url="item.avatar"
              >
                <span class="iconfont icontuanduibeifen text-24 text-fill-3"></span>
              </Avatar>
            </div>
            <div class="comment-info w-full flex flex-col justify-start">
              <div class="comment-title w-full">{{ item.title }}</div>
              <div class="comment-createTime w-full">{{ item.createTimeText }}</div>
              <div class="w-full pr-20">
                <div class="comment-content">{{ item.content }}</div>
                <div class="comment-operate">
                  <i
                    v-if="canUseComment"
                    key="reply"
                    class="iconfont iconxiaoxi reply-icon"
                    :title="$t('H9012')"
                    @click="replyMessage(item, true)"
                  />
                  <i
                    v-if="isMyself"
                    key="delete"
                    class="iconfont iconicon_jichutubiao_shanchu1 delete-icon"
                    :title="$t('C5004')"
                    @click="confirmDelete($event, item)"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>

        <div
          v-else
          class="no-comment"
        >
          <div>{{ $t('H1202') }}</div>
          <div>{{ $t('TD1019') }}</div>
        </div>
      </template>
      <template v-else>
        <!-- <scoped-loading></scoped-loading> -->
      </template>
    </div>
    <!--      输入评论-->
    <div
      v-if="canUseComment"
      class="comment-input"
    >
      <Textarea
        ref="replyContent"
        v-model="state.content"
        class="content-input"
        :placeholder="placeholder"
        :max-length="1500"
      ></Textarea>
      <!--        发布-->
      <div class="row-flex justify-end btn-group">
        <Button
          v-if="state.replyingItem"
          class="cancel-btn"
          @click="replyMessage(null, false)"
        >
          {{ $t('H9017') }}
        </Button>
        <Button
          class="reply-btn"
          :disabled="!canSubmit"
          @click="submit"
        >
          {{ $t('TD1021') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, reactive, getCurrentInstance } from 'vue';
import { Avatar, Button, Message, Textarea, Modal } from '@arco-design/web-vue';
import { activityDetailStore } from '@client/store/activityDetailStore';

const vm = getCurrentInstance();
Message._context = vm?.appContext;
const t = vm.proxy.$root.$t;

const replyContent = ref(null);
const activityDetailStoreRef = activityDetailStore();
const comments = computed(() => activityDetailStoreRef.commentList);
const canUseComment = computed(() => activityDetailStoreRef.activityDetail?.userProfile?.messageEditPermissions);
const isMyself = computed(() => activityDetailStoreRef.isMyself);

const state = reactive({
  replyingItem: null,
  isSubmitting: false,
  isDeletingComment: false,
  content: ''
});

const placeholder = computed(() => {
  if (state.replyingItem) {
    return t('H9019', { name: state.replyingItem.userInfo.nickname });
  }
  return t('H9014');
});

const canSubmit = computed(() => {
  return state.content.length !== 0 && state.content.length <= 1500;
});
async function confirmDelete(e, item) {
  Modal.confirm({
    content: t('H2017', { OvO: '' }),
    bodyClass: 'text-center',
    okText: t('C1005'),
    cancelText: t('C1006'),
    onOk: async () => {
      deleteComment(e, item);
    }
  });
}
function replyMessage(item, focus) {
  if (item) {
    state.replyingItem = item;
  } else {
    state.replyingItem = null;
  }

  if (focus) {
    replyContent.value.focus();
  }
}
async function submit(e, item) {
  if (!canSubmit.value) {
    return;
  }

  if (state.isSubmitting) {
    return;
  }
  state.isSubmitting = true;

  try {
    await activityDetailStoreRef.submitComment(state.content, state.replyingItem?.id);
    state.content = '';
    activityDetailStoreRef.getCommentList();
  } finally {
    state.isSubmitting = false;
  }
}
async function deleteComment(e, item) {
  if (!item.canDelete) {
    return;
  }

  if (state.isDeletingComment) {
    return;
  }

  state.isDeletingComment = true;
  try {
    await activityDetailStoreRef.deleteComment(item);
    activityDetailStoreRef.getCommentList();
  } finally {
    state.isDeletingComment = false;
  }
}
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';

.comment {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.comment-list {
  flex-grow: 1;
  padding: 8px 12px;
  //height: 189px;
  box-sizing: border-box;
  overflow: auto;

  .comment-item {
    margin-bottom: 12px;
    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }

    .avatar {
      margin: 6px 8px 0 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      font-size: 0;
      line-height: 0;
      border: 1px solid rgba(255, 255, 255, 0.6);
      box-sizing: border-box;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .comment-info {
      .comment-title {
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 16px;
      }

      .comment-createTime {
        margin-bottom: 6px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 20px;
      }

      .comment-content {
        margin: 0 0 4px 0;
        padding: 6px 8px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        //border-radius: 0 8px 8px 8px;
        box-sizing: border-box;
        white-space: pre-wrap;
      }

      .comment-operate {
        width: 100%;
        text-align: right;
        visibility: hidden;

        .iconfont {
          margin: 0 12px 0 0;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          transition: all 0.2s linear;

          &:nth-last-of-type(1) {
            margin: 0 0 0 0;
          }

          &:hover {
            color: rgba(0, 179, 255, 1);
          }
        }
      }
    }

    &.myself {
      flex-direction: row-reverse;

      .avatar {
        margin: 6px 0 0 8px;
      }

      .comment-info {
        align-items: flex-end;

        .comment-content {
          border-radius: 8px 0 8px 8px;
          background: rgba(255, 255, 255, 0.1);
        }

        .comment-operate {
          text-align: left;

          .iconfont {
            margin: 0 0 0 4px;
          }
        }
      }
    }

    &:hover {
      .comment-operate {
        visibility: visible;
      }
    }
  }

  .no-comment {
    padding: 0 16px;
    text-align: center;

    div {
      &:nth-of-type(1) {
        padding: 16px 0 12px 0;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
      }
      &:nth-of-type(2) {
        padding: 16px 0 12px 0;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}

.comment-input {
  padding: 12px 12px 22px 12px;
  box-sizing: border-box;

  .content-input {
    margin-bottom: 8px;
    width: 100%;
    height: 56px;
    font-size: 14px;
  }

  .btn-group {
    button {
      min-width: 100px;
      margin-right: 16px;
      padding: 0 16px;
      height: 32px;
      border-radius: 2px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      &:nth-last-of-type(1) {
        margin-right: 0;
      }

      &.cancel-btn {
        color: #ffffff;
        background: #283352;
      }

      &.reply-btn {
        color: #ffffff;
        background: #00b3ff;

        &[disabled] {
          color: rgba(255, 255, 255, 0.4);
          background-color: #232b40;
        }
      }
    }
  }
}
</style>
